import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-switch-button',
  templateUrl: './switch-button.component.html',
  styleUrls: ['./switch-button.component.css'],
})
export class SwitchButtonComponent implements OnInit {
  // isOn: boolean = false;
  @Input() value: any;
  @Input() disabled: any;
  @Output() eventHangler: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
    // this.isOn = this.value
    // console.log("activechild",this.isOn)
    // this.value
    console.log("d",this.disabled)
  }

  toggleHandler() {
    this.value = !this.value;
    this.eventHangler.emit(this.value);
  }
}
